"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineList = void 0;
/* eslint-disable react/jsx-curly-brace-presence */
var temas_frontend_1 = require("@aura/temas-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var check_disable_1 = __importDefault(require("../../token/icons/check-disable"));
var check_focus_1 = __importDefault(require("../../token/icons/check-focus"));
var check_success_1 = __importDefault(require("../../token/icons/check-success"));
var ternary_lint_util_1 = require("../../utils/ternary-utils/ternary-lint-util");
var styles_1 = require("./styles");
var TimelineList = function (_a) {
    var textSmall = _a.textSmall, textBodyBold = _a.textBodyBold, children = _a.children, className = _a.className, timelineState = _a.timelineState;
    var _b = (0, react_1.useState)(''), active = _b[0], setActive = _b[1];
    var _c = (0, react_1.useState)('0px'), height = _c[0], setHeight = _c[1];
    var _d = (0, react_1.useState)('timelineList-icon'), rotation = _d[0], setRotation = _d[1];
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var content = (0, react_1.useRef)(null);
    var sensitive = (0, react_1.useRef)(null);
    var toggleTimelineList = function () {
        var _a;
        setActive(active === '' ? 'active' : '');
        setHeight(active === 'active' ? '0px' : "".concat((_a = content === null || content === void 0 ? void 0 : content.current) === null || _a === void 0 ? void 0 : _a.scrollHeight, "px"));
        setRotation(active === 'active' ? 'timelineList-icon' : 'timelineList-icon rotate');
    };
    (0, hooks_1.useOnClickOutside)(sensitive, function () {
        setActive('');
        setHeight('0px');
        setRotation('timelineList-icon');
    });
    return (react_1.default.createElement(styles_1.TimelineListStyled, { ref: sensitive, className: "".concat(className, " ").concat(timelineState) },
        react_1.default.createElement(styles_1.HeaderStyled, { className: active, onClick: toggleTimelineList },
            react_1.default.createElement("div", { className: "headerTimelineList" },
                react_1.default.createElement("div", { className: "headerTimelineList-icon" }, timelineState === 'completed' ? (react_1.default.createElement(check_success_1.default, { width: "24px", height: "24px", stroke: theme.success })) : ((0, ternary_lint_util_1.retornaValorCondicionado)(timelineState === 'actived', react_1.default.createElement(check_focus_1.default, { width: "24px", height: "24px", stroke: theme.action001, className: "iconFocus" }), react_1.default.createElement(check_disable_1.default, { width: "24px", height: "24px", stroke: theme.grey004, className: "iconDisable" })))),
                react_1.default.createElement("div", { className: "headerTimelineList-text" },
                    react_1.default.createElement("p", { className: "textBodyBold" }, textSmall),
                    react_1.default.createElement("p", { className: "textSmall" }, textBodyBold))),
            react_1.default.createElement("div", { className: "".concat(active, " boxIcon ").concat(rotation) },
                react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ChevronDown, size: "md" }))),
        react_1.default.createElement(styles_1.BodyStyled, { ref: content, style: { maxHeight: "".concat(height) }, className: "".concat(active, " ").concat(timelineState, " timelineList__content") }, children)));
};
exports.TimelineList = TimelineList;
